export const DATA_ATTR = 'data-insurance';

export const selectors = {
    loader: '[data-loading-overlay]',
    component: `[${DATA_ATTR}-component]`,
    insuranceItem: `[${DATA_ATTR}-item]`,
    radio: 'input[type="radio"][name^="insurance-choice"]',
    basketFormButton: '#basket-form button[type="submit"]',
    modal: '.insurance-ipid-modal',
    modalTitle: `[${DATA_ATTR}-modal-title]`,
    modalTitleSource: `[${DATA_ATTR}-modal-title-value]`,
    modalConsent: `[${DATA_ATTR}-consent]`,
    modalAddToBasket: `[${DATA_ATTR}-add-to-basket]`,
    modalAnnualPrice: `[${DATA_ATTR}-annual-price]`,
    modalScrollableContainer: '[data-scrollable-container]',
    basketTotals: '[data-voucher="basket_totals"]',
    insuranceItemPrices: `[${DATA_ATTR}-prices]`,
    helpBlock: '.help-block',
    modalContent: '.modal-content',
};

export const findChosenInsuranceRadio = node => node.querySelector(`${selectors.radio}:checked`);
